var _rect, _text, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    role: "img",
    "aria-label": "Visa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 14,
    fill: "#1A1F71"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 56,
    fill: "#FFFFFF",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 30,
    fontStyle: "italic",
    fontWeight: 700,
    letterSpacing: 1.5,
    textAnchor: "middle"
  }, "VISA")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#F7B600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4f2156f9916570e956bb8df73e3e575e.svg";
export { ForwardRef as ReactComponent };